<!--共通住所(FS)-->
<template>
  <div style="border: 0px solid red; height:100%;width:100%;">
    <div class="modal-container-address" style="height:100%;width:100%;background: white;">
      <div class="modal-header">
        <!--住所検索-->
        <div style="width:100%;font-size: 15px;">{{$t('MODULE.DIALOG_LBL_ADDRESS_CONDITIONS')}}</div>
        <div style="width:100%;" align='right'>
          <el-button type="text" class="el-icon-close" style="color:white;" @click="closeDialog" circle></el-button>
        </div>
      </div>
      <!-- 对话框画面控件-->
      <!-- 对话框查询INPUT控件-->
      <div class="dialog-select-address">
        <el-row class="el-row-dialog-address">
          <el-col :span="6" class="el-row-dialog-address">
            <div align="left" style="padding-left:13px">
              <!--都道府県-->
              <span style="font-size: 10pt;">{{$t('MODULE.DIALOG_LBL_STATE')}}&nbsp;&nbsp;</span>
              <el-select @change="selectTodofukenList($event)" size="small" class="css-input-box-shadow css-dialog-input-width" v-model="todofuken" clearable>
                <el-option v-for="item in todofukenList" :key="item.stateCD" :label="item.stateName" :value="item.stateCD">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row class="el-row-dialog-address">
          <el-col :span="6" class="el-row-dialog-address">
            <div align="left" style="padding-left:13px">
              <!--市区町村-->
              <span style="font-size: 10pt;">{{$t('MODULE.DIALOG_LBL_CITY')}}&nbsp;&nbsp;</span>
              <el-select @change="selectShikuchosonList($event)" filterable size="small" class="css-input-box-shadow css-dialog-input-width" v-model="shikuchoson" clearable>
                <el-option v-for="item in shikuchosonList" :key="item.cityOnlyId" :label="item.cityName" :value="item.cityOnlyId">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row class="el-row-dialog-address">
          <el-col :span="6" class="el-row-dialog-address">
            <div align="left">
              <!--大字町丁目-->
              <span style="font-size: 10pt;">{{$t('MODULE.DIALOG_LBL_OAZAMA_CHICHOME')}}&nbsp;&nbsp;</span>
              <el-select ref="oazamachiChomeListRef" v-model="oazamachiChome" @change="selectOazamachiChomeList($event)" filterable size="small" class="css-input-box-shadow css-dialog-input-width" clearable>
                <el-option v-for="item in oazamachiChomeList" :key="item.oazamachiChomOnlyId" :label="item.oazamachiChomName" :value="item.oazamachiChomOnlyId">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row class="el-row-dialog-address">
          <el-col :span="6" class="el-row-dialog-address">
            <div align="left" style="padding-left:40px">
              <!--番地-->
              <span style="font-size: 10pt;">{{$t('MODULE.DIALOG_LBL_ADDRESS_BANCHI')}}&nbsp;&nbsp;</span>
              <el-select ref="select" @blur.native.capture="onblur" @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly" @change="selectAddressBanchiList($event)" filterable size="small" class="css-input-box-shadow css-dialog-input-width" popper-class="select-down" popper-append-to-body:false v-model="addressBanch" :clearable="clearableShow">
                <el-option v-for="item in addressBanchiList" :key="item.addressBanchiCd" :label="item.addressBanchiName" :value="item.addressBanchiCd">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <div style="padding-top:5px;padding-bottom:10px;padding-left:100px;">
          <!--検索ボタン-->
          <el-button type="primary" :disabled="queryButtonDisabled" style="margin-left:90px; width:40%;height:35px;" class="css-button css-btn" size="mini" @click="query_address">{{$t('COMMON.LBL_SEARCH')}}</el-button>
        </div>
      </div>
      <!-- 对话框TABLE-->
      <el-table :height="tableheight" :data="dialogTableData" :header-cell-style="dialogHeaderStyle" :cell-style="isCellStyle" stripe border size="mini">
        <!--選択-->
        <el-table-column prop="kselect" :label="$t('MODULE.DIALOG_TBL_CHOOSE')" width="50%" align="center">
          <template slot-scope="props">
            <i class="el-icon-collection" @click="onClickSelIcon(props.row)"></i>
          </template>
        </el-table-column>
        <!--都道府県-->
        <el-table-column prop="stateName" :label="$t('MODULE.DIALOG_LBL_STATE')" width="" align="center"></el-table-column>
        <!--市区町村-->
        <el-table-column prop="cityName" :label="$t('MODULE.DIALOG_LBL_CITY')" width="" align="center"></el-table-column>
        <!--大字町丁目-->
        <el-table-column prop="oazamachiChomName" :label="$t('MODULE.DIALOG_LBL_OAZAMA_CHICHOME')" width="90px" align="center"></el-table-column>
        <!--番地-->
        <el-table-column prop="addressBanchi" :label="$t('MODULE.DIALOG_LBL_ADDRESS_BANCHI')" width="" align="center"></el-table-column>
        <!--緯度-->
        <el-table-column prop="latitude" :label="$t('MODULE.DIALOG_LBL_LATITUDE')" width="90px" align="center"></el-table-column>
        <!--経度-->
        <el-table-column prop="longitude" :label="$t('MODULE.DIALOG_LBL_LONGITUDE')" width="90px" align="center"></el-table-column>
        <!--住所1-->
        <el-table-column prop="address1" width="" align="center" v-if="false"></el-table-column>
      </el-table>
      <!--分页-->
      <el-row class="pagination-row-address">
        <el-pagination class="pagination-page-address" background small @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page='params.page' :page-size="params.size" layout=" prev, pager, next" :total="total">
        </el-pagination>
      </el-row>
      <el-row class="pagination-row-address">
        <!--総計/件-->
        <span class="total-pages-address">{{$t('MODULE.DIALOG_LBL_TOTAL')}}{{total}}{{$t('MODULE.DIALOG_LBL_TOTAL_PIECE')}}&nbsp;&nbsp;</span>
        <span class="total-pages-address">{{$t('MODULE.DIALOG_LBL_TOTAL_PAGE')}}&nbsp;&nbsp;</span>
        <!--件/頁-->
        <el-select size="mini" class="pagination-select-address" @change="pageChanged" v-model="params.size" placeholder="">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-row>
    </div>
  </div>
</template>
<script>
import * as amsApi from '../api/dialogAddress'
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  name: '',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mainpostcode: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      tableheight: `${document.documentElement.clientHeight}`,
      x: 0,
      y: 0,
      node: null,
      isCanMove: false,
      code: '',
      name: '',
      total: 0, //总记录数
      params: {
        page: 1, //当前页码
        size: 10 //每页显示个数
      },
      options: [{
        value: 10,
        size: '10'
      }, {
        value: 20,
        size: '20'
      }, {
        value: 30,
        size: '30'
      }, {
        value: 40,
        size: '40'
      }],
      //TableList
      dialogTableData: [],
      //都道府県リスト
      todofukenList: [],
      //市区町村リスト
      shikuchosonList: [],
      //大字町丁目リスト
      oazamachiChomeList: [],
      oazamachiChomeListCopy: [],
      //番地リスト
      addressBanchiList: [],
      //都道府県
      todofuken: '',
      //市区町村
      shikuchoson: '',
      //大字町丁目
      oazamachiChome: '',
      //番地
      addressBanch: '',
      cityId: '',
      oazamachiChomId: '',
      queryButtonDisabled: true,
      clearableShow: false
    }
  },
  mounted() {
    //表格高度随着窗口大小而改变
    const that = this;
    window.onresize = () => {
      that.tableheight = `${document.documentElement.clientHeight}`;
      that.tableheight = parseInt(that.tableheight) - 340;
    };
  },
  created() {
    //表格高度随着窗口大小而改变
    this.tableheight = `${document.documentElement.clientHeight}`;
    this.tableheight = parseInt(this.tableheight) - 340;

    var queryParams = {}
    queryParams.postCode = this.mainpostcode;
    queryParams.processDiv = "0";

    //调用服务端接口
    amsApi.dialogApi(queryParams).then((res) => {
      if (res.code == 204) {
        this.todofukenList = res.items.stateSet
        if (res.items.stateDisp != "" && res.items.stateDisp != null) {
          this.todofuken = res.items.stateDisp.stateCD
        }
        this.shikuchosonList = res.items.citySet
        if (res.items.cityDisp != "" && res.items.cityDisp != null) {
          this.shikuchoson = res.items.cityDisp.cityOnlyId
          //大字町丁目赋值_町域名
          this.oazamachiChome = res.items.cityDisp.townName
        }
        this.oazamachiChomeList = res.items.oazamachiChomeSet
        //备份初始化的大字町丁目リスト
        this.oazamachiChomeListCopy = JSON.parse(JSON.stringify(this.oazamachiChomeList))
        if (this.oazamachiChome != "" && this.oazamachiChome != null) {
          //大字町丁目赋值后筛选
          this.oazamachiChomeListFilter(this.oazamachiChome)
          //弹出大字町丁目下拉列表
          this.$refs.oazamachiChomeListRef.toggleMenu()
        }
      }
    }).catch((err) => {

    });
  },
  watch: {
    //监听下拉列表
    oazamachiChome: function (value) {
      if (value != "" && value != null && this.oazamachiChomId != "" && this.oazamachiChomId != null) {
        this.queryButtonDisabled = false;
      } else {
        this.queryButtonDisabled = true;
      }
    }
  },
  methods: {
    // el-select_ios对应:失去焦点
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur()
        }
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100);
    },
    //el-select_ios对应:取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (onOff) {
          this.clearableShow = true
        }
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector('.el-input__inner')
          input.removeAttribute('readonly')
          this.clearableShow = false
        }
      })
    },
    //判断TABLE单元格样式
    isCellStyle({ row, colum, rowIndex, columnIndex }) {
      if (columnIndex > 0) {
        return this.dialogCellStyle_left();
      }
    },
    //分页
    handleSizeChange(size) {
      this.params.size = size
    },
    // 改变当前页并刷新页面
    handleCurrentChange(page) {
      this.params.page = page;
      this.query();
    },
    pageChanged() {
      this.params.page = 1;
      this.query();
    },
    //住所検索
    query_address() {
      this.params.page = 1;
      this.query();
    },
    query() {
      this.params.postCode = this.mainpostcode;
      this.params.stateCD = this.todofuken;
      this.params.cityCD = this.cityId;
      this.params.oazamachiChomeCd = this.oazamachiChomId;
      this.params.addressBanchiCd = this.addressBanch;
      this.params.cityOnlyId = this.shikuchoson;
      this.params.oazamachiChomOnlyId = this.oazamachiChome;

      this.params.processDiv = "4"

      //调用服务端接口
      amsApi.dialogApi(this.params).then((res) => {
        if (res.code == 204) {
          //将res结果数据赋值给数据模型对象
          if (this.params.page == 1) {
            this.total = res.total;
          }
          //TableList
          this.dialogTableData = res.items.addressSet;
          //住所1⇒都道府県＋市区町村＋大字町丁目＋番地												
          for (var i = 0; i < this.dialogTableData.length; i++) {
            this.dialogTableData[i].address1 = this.dialogTableData[i].stateName +
              this.dialogTableData[i].cityName +
              this.dialogTableData[i].oazamachiChomName +
              this.dialogTableData[i].addressBanchi
          }
        } else if (res.code == 300) {
          this.dialogTableData = []
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
        }
      }).catch((err) => {

      });
    },
    //都道府県切替
    selectTodofukenList(val) {
      if (val != "") {
        var queryParams = {}
        queryParams.stateCD = val;
        queryParams.processDiv = "1";

        //调用服务端接口
        amsApi.dialogApi(queryParams).then((res) => {
          if (res.code == 204) {
            this.shikuchosonList = res.items.citySet
          }
          this.shikuchoson = ""
          this.oazamachiChome = ""
          this.addressBanch = ""
          this.oazamachiChomeList = []
          this.addressBanchiList = []
          this.dialogTableData = []
        }).catch((err) => {
        });
      } else {
        this.shikuchoson = ""
        this.oazamachiChome = ""
        this.addressBanch = ""
        this.shikuchosonList = []
        this.oazamachiChomeList = []
        this.addressBanchiList = []
        this.dialogTableData = []
      }
    },
    //市区町村切替
    selectShikuchosonList(val) {
      if (val != "") {
        var queryParams = {}
        queryParams.cityOnlyId = val;
        queryParams.processDiv = "2";

        let obj = {};
        obj = this.shikuchosonList.find((item) => {
          return item.cityOnlyId === val;
        });

        queryParams.cityCD = obj.cityCD
        this.cityId = obj.cityCD

        //调用服务端接口
        amsApi.dialogApi(queryParams).then((res) => {
          if (res.code == 204) {
            this.oazamachiChomeList = res.items.oazamachiChomeSet
          }
          this.oazamachiChome = ""
          this.addressBanch = ""
          this.addressBanchiList = []
          this.dialogTableData = []
        }).catch((err) => {

        });
      } else {
        this.oazamachiChome = ""
        this.addressBanch = ""
        this.oazamachiChomeList = []
        this.addressBanchiList = []
        this.dialogTableData = []
      }
    },
    //大字町丁目切替
    selectOazamachiChomeList(val) {
      if (val != "") {
        var queryParams = {}
        queryParams.oazamachiChomOnlyId = val;
        queryParams.processDiv = "3";

        let obj = {};
        obj = this.oazamachiChomeList.find((item) => {
          return item.oazamachiChomOnlyId === val;
        });

        queryParams.oazamachiChomeCd = obj.oazamachiChomCD
        this.oazamachiChomId = obj.oazamachiChomCD

        //调用服务端接口
        amsApi.dialogApi(queryParams).then((res) => {
          if (res.code == 204) {
            this.addressBanchiList = res.items.addressBanchiSet
          }
          this.addressBanch = ""
          this.dialogTableData = []
        }).catch((err) => {

        });
      } else {
        this.addressBanch = ""
        this.addressBanchiList = []
        this.dialogTableData = []
        this.oazamachiChomeList = this.oazamachiChomeListCopy
      }
    },
    //番地切替
    selectAddressBanchiList(val) {
      this.params.page = 1;
      this.query();
    },
    //过滤大字町丁目
    oazamachiChomeListFilter(val) {
      if (val) {
        let value = val.toUpperCase();
        this.oazamachiChomeList = this.oazamachiChomeListCopy.filter((item) => {
          if (item.oazamachiChomCD != null) {
            if (item.oazamachiChomCD.indexOf(value) > -1 || item.oazamachiChomName.indexOf(value) > -1) {
              return true
            }
          }
        })
      } else {
        this.oazamachiChomeList = this.oazamachiChomeListCopy;
      }
    },
    closeDialog() {
      this.dialogTableData = [];
      this.$emit('closeAddressDialog');
    },

    onClickSelIcon(row) {
      for (const key in row) {
        if (row[key] == null) {
          row[key] = ""
        }
      }
      this.dialogTableData = [];
      this.$emit('submitAddressDialog', row);
    },
    dialogHeaderStyle() {
      return 'fontSize:13px;background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);';
    },
    isCellStyle() {
      return 'fontSize:12px;';
    }
  }
}
</script>
<style>
/*分页样式*/
/*分页行背景色、尺寸样式*/
.pagination-row-address {
  height: 36px;
  background-image: linear-gradient(#888888, #444444);
  border-radius: 4px;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.48);
}
/*分页组件样式*/
.pagination-page-address {
  float: left;
  padding-top: 2px;
  margin-top: 5px;
  width: 1000px;
}
/*分页总页码字体*/
.total-pages-address {
  font-size: 9pt;
  float: right;
  padding-top: 8px;
  color: #ffffff;
  padding-left: 5px;
}
/*选择每页显示条数样式*/
.pagination-select-address {
  float: right;
  width: 65px;
  height: 12px;
  padding-top: 4px;
  padding-left: 10px;
}
.dialog-select-address {
  padding-top: 20px;
  padding-bottom: 2px;
  width: 100%;
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
  border: solid 0px #23b2e8;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.48);
}
.el-row-dialog-address {
  padding-left: 20px;
  margin-bottom: 5px;
  border-radius: 4px;
  width: 350px;
}
.modal-container-address {
  background: #fff;
  border-radius: 10px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.select-down .el-select-dropdown__wrap {
  max-height: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/dialogAddress.vue